import { render } from "./LinkedObject.vue?vue&type=template&id=5ba7f3ae&scoped=true"
import script from "./LinkedObject.vue?vue&type=script&lang=js"
export * from "./LinkedObject.vue?vue&type=script&lang=js"

import "./LinkedObject.vue?vue&type=style&index=0&id=5ba7f3ae&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba7f3ae"]])

export default __exports__